import { useQuery } from "@tanstack/react-query";
import { supabase } from "@/lib/supabase";

interface BusinessData {
  total_paying_users: number;
  conversion_rate: number | null;
  by_tier: Record<string, number>;
  avg_days_to_convert: number | null;
  upgrades_this_week: number;
  upgrades_this_month: number;
  gifts_sent: number;
  gifts_sent_this_month: number;
  gifts_redeemed: number;
  gift_redemption_rate: number | null;
  gifts_by_occasion: Record<string, number> | null;
  gifts_by_tier: Record<string, number> | null;
  invite_acceptance_rate: number | null;
  invites_sent_this_month: number;
  cancellations_this_month: number;
}

export function useBusinessMetrics() {
  const query = useQuery({
    queryKey: ["business-metrics"],
    queryFn: async () => {
      const { data, error } = await supabase.rpc("get_business_dashboard");
      if (error) throw error;
      return data as unknown as BusinessData;
    },
  });

  return {
    data: query.data,
    isLoading: query.isLoading,
    isError: query.isError,
    error: query.error as Error | null,
    refetch: query.refetch,
  };
}
